// Regra global: tecla Enter em inputs/selects move o foco pro proximo campo
// (igual ao Tab). Convem em formularios — evita submit acidental e padroniza
// navegacao por teclado em desktops.
//
// NAO se aplica a:
//   - Textareas (Enter cria linha)
//   - Buttons / links / submits (Enter = click)
//   - Inputs com modificadores (Shift+Enter, Ctrl+Enter, etc)
//   - Elementos dentro de container com data-no-enter-tab="true"
//   - Quando o handler local fez stopPropagation/preventDefault

function isFocavel(el: Element): boolean {
  if (!(el instanceof HTMLElement)) return false;
  if (el.hasAttribute('disabled')) return false;
  if (el.tabIndex < 0) return false;
  if (el.offsetParent === null && el.tagName !== 'BUTTON') return false; // hidden
  const tag = el.tagName;
  if (tag === 'INPUT') {
    const type = (el as HTMLInputElement).type;
    return type !== 'hidden';
  }
  return tag === 'SELECT' || tag === 'TEXTAREA' || tag === 'BUTTON' || tag === 'A';
}

function listarFocaveis(): HTMLElement[] {
  const sel = 'input, select, textarea, button, a[href], [tabindex]:not([tabindex="-1"])';
  return Array.from(document.querySelectorAll<HTMLElement>(sel)).filter(isFocavel);
}

function avancarFoco(atual: HTMLElement, reverso = false) {
  const focaveis = listarFocaveis();
  const idx = focaveis.indexOf(atual);
  if (idx < 0) return;
  const passo = reverso ? -1 : 1;
  for (let i = idx + passo; i >= 0 && i < focaveis.length; i += passo) {
    const el = focaveis[i];
    if (el) { el.focus(); return; }
  }
}

function onKeydown(e: KeyboardEvent) {
  if (e.key !== 'Enter') return;
  if (e.altKey || e.ctrlKey || e.metaKey) return;
  if (e.defaultPrevented) return; // handler local ja tratou
  const target = e.target as HTMLElement | null;
  if (!target) return;

  const tag = target.tagName;
  // Textarea: Enter cria linha. Button/A: Enter clica. Nao mexer.
  if (tag === 'TEXTAREA' || tag === 'BUTTON' || tag === 'A') return;
  if (tag === 'INPUT') {
    const type = (target as HTMLInputElement).type;
    if (type === 'submit' || type === 'button' || type === 'reset'
        || type === 'checkbox' || type === 'radio' || type === 'file') return;
  } else if (tag !== 'SELECT') {
    return;
  }

  // Opt-out via data-attribute em algum ancestral
  if (target.closest('[data-no-enter-tab]')) return;

  e.preventDefault();
  avancarFoco(target, e.shiftKey);
}

let instalado = false;

export function instalarEnterAsTab(): void {
  if (instalado) return;
  instalado = true;
  document.addEventListener('keydown', onKeydown);
}
